// Shared navigation config for the sidebar, the "Full Menu" overlay and the
// dashboard quick-access cards. Items are filtered by permission at render time.
import React from "react";
import {
  FaUser, FaUserShield, FaPalette, FaUserTie, FaSitemap, FaCalendarAlt,
  FaPuzzlePiece, FaPrayingHands, FaSun, FaStar, FaGopuram, FaLanguage,
  FaChild, FaBookReader, FaOm, FaSchool, FaLandmark, FaPenFancy,
  FaQuestion, FaQuoteRight, FaUtensils, FaSpa, FaPaperPlane, FaMobileAlt,
} from "react-icons/fa";

export const NAV_GROUPS = [
  {
    key: "inhoud",
    label: "Spiritueel",
    items: [
      { key: "prayers", label: "Gebeden", icon: FaPrayingHands, color: "#ff6e00" },
      { key: "dailyprayers", label: "Dagelijkse gebeden", icon: FaSun, color: "#f59e0b" },
      { key: "specialdays", label: "Speciale dagen", icon: FaStar, color: "#eab308" },
      { key: "dharmalearning", label: "Dharma leer", icon: FaOm, color: "#c2410c" },
      { key: "hindilearning", label: "Hindi leren", icon: FaLanguage, color: "#0d9488" },
      { key: "quizzes", label: "Quizzen", icon: FaPuzzlePiece, color: "#7c3aed" },
      { key: "ebibliotheek", label: "E-Bibliotheek", icon: FaBookReader, color: "#2563eb" },
    ],
  },
  {
    key: "artikelen",
    label: "Artikelen",
    items: [
      { key: "blogs", label: "Blogs", icon: FaPenFancy, color: "#db2777" },
      { key: "kyun", label: "Kyun", icon: FaQuestion, color: "#9333ea" },
      { key: "dailyquotes", label: "Dagelijkse quotes", icon: FaQuoteRight, color: "#0891b2" },
      { key: "bhojan", label: "Bhojan", icon: FaUtensils, color: "#dc2626" },
      { key: "yoga", label: "Yoga", icon: FaSpa, color: "#16a34a" },
    ],
  },
  {
    key: "organisatie",
    label: "Organisatie",
    items: [
      { key: "events", label: "Evenementen", icon: FaCalendarAlt, color: "#e11d48" },
      { key: "mandirs", label: "Mandirs", icon: FaGopuram, color: "#ea580c" },
      { key: "pandits", label: "Pandits", icon: FaUserTie, color: "#92400e" },
      { key: "departments", label: "Afdelingen", icon: FaSitemap, color: "#4f46e5" },
      { key: "hoofdbestuur", label: "Hoofdbestuur", icon: FaLandmark, color: "#475569" },
      { key: "schools", label: "Scholen", icon: FaSchool, color: "#0284c7" },
      { key: "kinderhuis", label: "Kinderhuis", icon: FaChild, color: "#65a30d" },
    ],
  },
  {
    key: "beheer",
    label: "Beheer",
    items: [
      { key: "users", label: "Gebruikers", icon: FaUser, color: "#2563eb" },
      { key: "roles", label: "Rollen & rechten", icon: FaUserShield, color: "#7c3aed" },
      { key: "appgroups", label: "App-menu & groepen", icon: FaMobileAlt, color: "#0d9488" },
      { key: "branding", label: "Logo per periode", icon: FaPalette, color: "#db2777" },
      { key: "mail", label: "Mail", icon: FaPaperPlane, color: "#0891b2" },
    ],
  },
];

export const pathFor = (key) => `/admin/${key}`;

// Groups with only the items the account may view.
export const visibleGroups = (canView) =>
  NAV_GROUPS
    .map((group) => ({ ...group, items: group.items.filter((item) => canView(item.key)) }))
    .filter((group) => group.items.length > 0);

export const NavIcon = ({ item, className = "nav-icon", style }) => {
  const Icon = item.icon;
  return (
    <span className={className} style={{ "--icon-color": item.color, ...style }} aria-hidden="true">
      <Icon />
    </span>
  );
};
